import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/questionnaires/(pages)/(list)')(
  {
    component: lazyRouteComponent(
      () => import('../../-components/QuestionnairesLayout'),
      'QuestionnairesLayout',
    ),
  },
);
